export default __webpack_public_path__ + "de24e1fa871429b7b606813e1bf2260e.png";